import React from 'react';
import { DocumentTreeItem } from '../common/CommonTypes';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeItem } from '@mui/x-tree-view';

type DocTreeItemProps = {
  item: DocumentTreeItem;
  children?: React.ReactNode;
};

const DocTreeItem = ({ item, children }: DocTreeItemProps): JSX.Element => {
  const onClick = () => {
    if (item.path) {
      window.open(item.path, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <TreeItem
      key={item.id}
      itemId={item.id}
      label={item.name}
      onClick={onClick}
      slots={{ endIcon: item.showIcon ? ChevronRightIcon : undefined }}>
      {children}
    </TreeItem>
  );
};

export default DocTreeItem;
